<template>
  <Section>
    <template #header>
      <div class="mr-auto">
        <strong style="color:black">User Details</strong>
      </div>
      <UserDialog :user="currentUser" />
    </template>
    
    <Item icon="mdi-account-box-outline">
      {{ currentUser.display_name }}
      <v-icon color="primary" class="mb-1" small v-if="currentUser.role == 'admin'">
        mdi-crown
      </v-icon>
      <v-icon color="#F47C02" small v-if="currentUser.default_rewards_user">
        mdi-qrcode
      </v-icon>
    </Item>
    <Item icon="mdi-account">{{ currentUser.name }}</Item>
    <Item icon="mdi-email">{{ currentUser.email }}</Item>
    <Item icon="mdi-calendar-month">Last login: {{ last_login }}</Item>
    <Item icon="mdi-qrcode" color="#F47C02" class="mt-3">
      <div style="font-style: italic; font-size: 14px;">
        To update the designated user for outside referrals, please contact us at
        <a href="mailto:support@referra.pro">support@referra.pro</a>.
      </div>
    </Item>
  </Section>
</template>

<script>
import { Item, Section } from '@/components/pages'
import { mapGetters } from 'vuex'
import UserDialog from '../dialogs/User'

export default {
  name: 'UserDetailsSection',

  components: { Item, Section, UserDialog },

  props: ['user_id'],

  computed: {
    ...mapGetters('users', ['currentUser']),

    last_login() {
      return this.currentUser.last_login ? this.$formatters.formatDate(this.currentUser.last_login) :  'Never'
    }
  },
}
</script>
